module.exports = __webpack_public_path__ + "img/logo-mazzitech.a0b3a1d6.png";